// Pricing engine — mirrors fixlr.app's billing catalog semantics.
export const money = (n, opts = {}) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: opts.dp ?? 2, maximumFractionDigits: opts.dp ?? 2 }).format(n);

export const sameSet = (a = [], b = []) => a.length === b.length && [...a].sort().every((k, i) => k === [...b].sort()[i]);

// New paid add-ons not yet in the fixlr.app billing catalog — shown as "Price TBC", never added to totals.
export const UPCOMING_ADDONS = [
  { key: "email_inbox", label: "Email-to-Job Inbox", blurb: "Connect a mailbox; emails become triaged jobs with the thread attached.", href: "/product/email-inbox" },
  { key: "asset_tagging", label: "Asset Tagging (QR + NFC)", blurb: "Printable tags on every asset — scan to raise a job, logged as proof of presence.", href: "/product/asset-tagging" },
  { key: "ai_rams", label: "AI RAMS", blurb: "Risk assessment & method statement drafted from the job, approved and signed on site.", href: "/product/ai-rams" },
  { key: "toolbox_talks", label: "Toolbox Talks", blurb: "Schedule, deliver on the phone, capture signatures, file per job and person.", href: "/product/toolbox-talks" },
];

export function computePlan({ seats, addons, annual, catalog }) {
  if (!catalog) return null;
  const perUser = catalog.config.per_user_monthly;
  const addonTotal = catalog.addons.filter((a) => addons.includes(a.key)).reduce((s, a) => s + a.monthly_price, 0);
  const list = seats * perUser + addonTotal;
  const preset = catalog.presets.find((p) => sameSet(p.feature_keys, addons));
  const discountPct = preset ? preset.bundle_discount_pct : 0;
  const monthly = list * (1 - discountPct / 100);
  const annualTotal = monthly * 12 * (1 - catalog.config.annual_discount_pct / 100);
  return {
    list,
    discountPct,
    preset,
    monthly,
    annualTotal,
    annualMonthlyEq: annualTotal / 12,
    seatsCost: seats * perUser,
    addonTotal,
    effective: annual ? annualTotal / 12 : monthly,
    savings: annual ? monthly * 12 - annualTotal : list - monthly,
  };
}
